export default class Sort {
  static alphabetic = (array, key = 'name') => [...array].sort((a, b) => a[key].localeCompare(b[key]));
}
